<template>
  <div id="clients-list">
    <div class="row">
      <div class="col-12">
        <table class="table" v-if="$store.state.responsive.viewDesktopLists">
          <thead class="fixheader">
            <tr>
              <th scope="col" class="align-middle">
                <ThOrder :textHeader="'Marca'" :idHeader="'brand'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th scope="col" class="align-middle">
                <ThOrder :textHeader="'Modelo'" :idHeader="'model'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th scope="col" class="align-middle">
                <ThOrder :textHeader="'Capacidad'" :idHeader="'capacity'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th scope="col" class="align-middle">
                <ThOrder :textHeader="'Color'" :idHeader="'color'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th scope="col" class="align-middle">
                <ThOrder :textHeader="'Stock'" :idHeader="'stock'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th scope="col" class="align-middle">
                <ThOrder :textHeader="'Cuota mensual'" :idHeader="'cuota'" :currentOrderBy="currentOrderBy"
                  @selectOrder="selectOrder($event)"></ThOrder>
              </th>
              <th scope="col" class="align-middle py-4">Operaciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in productsAux" v-bind:key="product.clientId">
              <td class="align-middle py-4">{{ product.brand }}</td>
              <td class="align-middle py-4">{{ product.model }}</td>
              <td class="align-middle py-4">{{ product.capacity }}</td>
              <td class="align-middle py-4">{{ product.color }}</td>
              <td class="align-middle py-4">
                <div v-if="product.stock > 0" class="stockTable">Sí</div>
                <div v-else class="noStockTable">No</div>
              </td>
              <td class="align-middle py-4">{{ product.totalPrice }}€</td>
              <td class="align-middle py-4">
                <button v-if="product.stock > 0" @click="selectProduct(product.ean)"
                  class="btn generalTertiaryButton">Seleccionar</button>
              </td>
            </tr>
          </tbody>
        </table>
        <template v-if="!$store.state.responsive.viewDesktopLists">
          <div class="card p-2 mb-3" v-for="product in productsAux" v-bind:key="product.clientId">  
            <div class="list-item">
              <div class="item d-flex align-items-center justify-content-between collapsed px-2 py-3" data-toggle="collapse"
                :href="'#collapseExample' + index" role="button" aria-expanded="true"
                :aria-controls="'collapseExample' + index">
                <h4 class="m-0">{{ product.brand }} {{ product.model }} {{product.capacity}} {{product.color}}</h4>
                <v-icon name="bi-chevron-up" />
              </div>
              <div class="collapse show ml-3 mr-2" :id="'collapseExample' + index">
                <div class="d-flex align-items-center justify-content-between flex-wrap mb-2 mt-2">
                  <div class="d-flex align-items-center justify-content-start">
                    <p class="m-0 mr-2"><strong>Marca: </strong>{{ product.brand }}</p>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
                  <p class="m-0 mr-2"><strong>Modelo: </strong>{{ product.model }}</p>
                </div>
                <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
                  <p class="m-0 mr-2"><strong>Capacidad: </strong>{{ product.capacity }}</p>
                </div>
                <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
                  <p class="m-0 mr-2"><strong>Color: </strong>{{ product.color }}</p>
                </div>
                <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
                  <p class="m-0 mr-2"><strong>Stock: </strong></p>
                  <div v-if="product.stock > 0" class="stockTable">Sí</div>
                  <div v-else class="noStockTable">No</div>
                </div>
                <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
                  <p class="m-0 mr-2"><strong>Cuota mensual: </strong>{{ product.totalPrice }}€</p>
                </div>
                <div v-if="product.stock > 0" class="d-flex align-items-center justify-content-start flex-wrap mb-2">
                  <button @click="selectProduct(product.ean)" class="btn generalTertiaryButton">Seleccionar</button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ThOrder from '../../../../Shared/ThOrder.vue';
import axios from 'axios';

export default {
  name: 'NewContractProductList',
  props: [
    'products',
  ],
  data() {
    return {
      currentOrder: '',
      currentOrderBy: '',
      productsAux: this.products,
    };
  },
  updated() {
    this.productsAux = this.products
  },
  components: {
    ThOrder,
  },
  methods: {
    async selectProduct(ean) {
      axios.get(`/products/get-by-ean/${ean}`)
        .then(async (response) => {
          const bodyToSave = {
            id: response.data.id,
            supplier: response.data.merchantData.merchant,
            brand: response.data.brand,
            model: response.data.model,
            capacity: response.data.capacity,
            ean: response.data.merchantData.ean,
            color: response.data.color,
            price: response.data.prices.payment.totalFee * response.data.prices.payment.fees,
            nQuotas: response.data.prices.payment.fees,
            quotaPrice: response.data.prices.payment.totalFee,
            stock: response.data.stock,
            partCode:response.data.merchantData.merchantCode
          }
          this.$store.commit('setNewContractDataProduct', bodyToSave);
          this.$router.push({ name: 'renewContractStep2' })
        });


    },
    selectOrder(value) {
      this.productsAux = this.productsAux.sort(function (a, b) {
        let valorA = a[value.orderBy] == null || a[value.orderBy] == undefined ? 0 : a[value.orderBy]
        let valorB = b[value.orderBy] == null || b[value.orderBy] == undefined ? 0 : b[value.orderBy]
        if (value.orderBy == "capacity") {
          valorA = parseInt(a[value.orderBy].slice(0, -2))
          valorB = parseInt(b[value.orderBy].slice(0, -2))
        }
        if (valorA < valorB) return -1
        if (valorA > valorB) return 1
      })
      if (value.order == 'DESC') this.productsAux = this.productsAux.reverse()
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#operaciones {
  text-align: right;
}

thead {
  background-color: rgb(250, 250, 250);
}

.col-12 {
  padding: 0%;
}
</style>
